<template>
    <div :class="style.overlay"></div>
</template>

<script>
    import Vue from 'vue'
    import style from './style.module.scss'

    export default Vue.extend({
        name: 'overlay',
        components: {

        },
        props: {

        },
        data() {
            return {
                style: style
            }
        },
    })
</script>